import { getSearchParam } from '@/utils/helpers';
import type { Channels } from '@/utils/api/channel';

const defaults = {
  terms: [12, 24, 36, 48, 60],
  amount: '10000',
  channel: 'upl',
  maximum: 25000,
  minimum: 1000,
  term: '12',
};

export const getAmount = (): string => {
  const amount = Number.parseInt(getSearchParam('amount') || defaults.amount);

  return !Number.isNaN(amount) ? `${amount}` : defaults.amount;
};

export const getMinimum = () => defaults.minimum;

export const getMaximum = () => defaults.maximum;

export const getChannel = () => defaults.channel as Channels;

export const getTerms = (datoTerms?: string[]): number[] =>
  datoTerms ? datoTerms.map((number) => Number.parseInt(number)) : defaults.terms;

export const getTerm = (datoTerms?: string[]): number => {
  if (!datoTerms) {
    return Number.parseInt(defaults.term);
  }

  const term = getSearchParam('term') || defaults.term;

  return Number.parseInt(datoTerms.indexOf(term) === -1 ? datoTerms[datoTerms.length - 1] || defaults.term : term);
};
